import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path d="M6 19h12v2H6z" />, 'Minimize');
